import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { intersection, union, pull } from 'lodash-es';

import { Course, UserInfo } from '../../models/user';

@Component({
  selector: 'app-manage-courses-dialog',
  templateUrl: './manage-courses-dialog.component.html',
  styleUrls: ['./manage-courses-dialog.component.scss'],
})
export class ManageCoursesDialogComponent implements OnInit {
  search = '';
  filteredCourses: Course[] = [];
  selectedUsers: UserInfo[] = [];
  title: string;
  updates: { _id: string; courses: string[] }[] = [];
  isSelectionMixed = false;
  checkedCourses = 0;

  constructor(
    public dialogRef: MatDialogRef<ManageCoursesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.filteredCourses = [...this.data?.courses];
    this.selectedUsers = [...this.data?.selectedUsers];
    this.title = this.data.title;
  }

  ngOnInit(): void {
    const allUserCourses: any = [];
    this.selectedUsers.forEach((user) => {
      allUserCourses.push(user.courses);
      this.updates.push({ _id: user._id, courses: [...user.courses] });
    });
    const commonCourses = intersection(...allUserCourses);
    this.checkedCourses = union(...allUserCourses).length;
    this.isSelectionMixed = commonCourses.length > 0 && this.selectedUsers.length > 1;
  }

  handleSearch(val: string): void {
    if (val === '') {
      this.filteredCourses = this.data?.courses;
    } else {
      this.filteredCourses = this.data?.courses.filter((course: Course) =>
        course.name.toLowerCase().includes(val.toLowerCase()),
      );
    }
  }

  handleCourseClick(courseId: string, event: MatCheckboxChange): void {
    if (event.checked) {
      this.updates.forEach((user) => {
        if (!user.courses.includes(courseId)) {
          user.courses.push(courseId);
        }
      });
    } else {
      this.updates.forEach((user) => {
        user.courses = pull(user.courses, courseId);
      });
    }

    const allUserCourses = this.updates.map((user) => user.courses);
    this.checkedCourses = union(...allUserCourses).length;
  }

  courseSelectionState(courseId: string): 'all' | 'partial' | 'none' {
    const every = this.updates.every((user) => user.courses.includes(courseId));
    if (every) {
      return 'all';
    }

    const some = this.updates.some((user) => user.courses.includes(courseId));
    if (some) {
      return 'partial';
    }

    return 'none';
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.dialogRef.close(this.updates);
  }
}
